import { withFeatureFlags } from '@/flags.server';

import { fetchTradePageProps } from '@/components/pages/Trade/fetchTradePageProps.server';
import {
  TradePage as TradePageComponent,
  TradePageServerProps,
} from '@/components/pages/Trade/TradePage';

const TradePage = (props: TradePageServerProps) => (
  <TradePageComponent {...props} iFrameContext={true} />
);

export default TradePage;

export const getServerSideProps = withFeatureFlags(async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  const props = await fetchTradePageProps(ctx);

  return props;
});
